import {makeAutoObservable} from 'mobx';
import * as Api from "api/api";

class Cart {
    info = null;
    list = [];
    recommendList = [];
    goodsCount = 0;
    recommendPageSize = 5;
    recommendPageNum = 1;
    loadingInfo = false;
    loadingRecommend = false;

    get allActive() {
        for (let i in this.list) {
            if (this.list[i].active === false) {
                return false;
            }
        }

        return true;
    }

    get activeCount() {
        return this.activeList.length;
    }

    get activeList() {
        return this.list.filter(item => item.active);
    }

    get activeTotalPrice() {
        return this.list
            .filter(item => item.active)
            .reduce((sum, item) => {
                return sum + item.goodsTotalPrice;
            }, 0);
    }

    /**
     * 获取购物车详情
     */

    async fetchInfo() {
        try {
            this.loadingInfo = true;
            const {info, list} = await Api.cartInfo();

            this.info = info;
            this.list = await Promise.all(
                list.map(async item => {
                    const {goodsId} = item;
                    let {list: skuList} = await Api.skuListByGoodsId({goodsId});
                    skuList = skuList.map(sku => {

                        const specification = sku.specificationNameAndValues
                            ?.map(spec => spec.name)
                            .join(',');

                        return {
                            id: sku.id,
                            goodsId: sku.goodsId,
                            specification: specification
                        };
                    });

                    return {
                        ...item,
                        active: false,
                        skuList
                    };
                })
            );

        } catch (error) {
            console.error(error);
        } finally {
            this.loadingInfo = false;
        }
    }

    /**
     * 选择商品
     * @param {*} index
     * @param {*} active
     */
    modifyActive(index, active) {
        this.list = this.list.map((item, i) => {
            if (i === index) {
                return {
                    ...item,
                    active
                };
            } else {
                return item;
            }
        });
    }

    /**
     * （取消）全选
     * @param {*} active
     */
    modifyAllActive(active) {
        this.list = this.list.map(item => {
            return {
                ...item,
                active
            };
        });
    }

    /**
     * 修改商品数量
     * @param {*} cartId
     * @param {*} goodsId
     * @param {*} skuId
     * @param {*} number
     */

    async modifyGoodsCount(cartId, goodsId, skuId, number) {
        try {
            for (let key in this.list) {
                let goods = this.list[key];

                if (skuId === goods.productId) {
                    await Api.cartModifyGoodsNum({
                        goodsId,
                        skuId,
                        number,
                        cartId
                    });

                    await this.fetchInfo();

                    return;
                }
            }
        } catch (error) {
        }
    }

    /**
     * 删除商品
     * @param {*} cartIdList
     */

    async deleteCart(cartIdList) {
        try {
            await Api.cartDelete({cartIdList});
            await this.fetchInfo();
        } catch (error) {
        }
    }

    /**
     * 修改sku
     * @param {*} param0
     */

    async changeSku({cartId, goodsId, skuId, newSkuId, number}) {
        try {
            await Api.cartChangSku({cartId, goodsId, skuId, newSkuId, number});
            this.fetchInfo();
        } catch (error) {
        }
    }

    /**
     * 获取推荐商品
     * @param {*} param0
     */

    async fetchRecommendList({pageSize, pageNum}) {
        try {
            this.loadingRecommend = true;
            let {list} = await Api.recommendList({
                pageSize,
                pageNum
            });

            list = list.splice(0, pageSize);

            this.recommendList = list.map(item => {
                const {
                    id,
                    name,
                    originPrice,
                    currentPrice,
                    shopId,
                    soldNum,
                    mainPic,
                    hasCollect,
                    collectId,
                    categoryId,
                    isHot,
                    isNew,
                    isSpecialPrice,
                    pddShop,
                    isPddShop,
                    isJdShop
                } = item;

                return {
                    id,
                    name,
                    originPrice,
                    currentPrice,
                    shopId,
                    soldNum,
                    mainPic,
                    hasCollect,
                    collectId,
                    categoryId,
                    isHot,
                    isNew,
                    isSpecialPrice,
                    pddShop,
                    isPddShop,
                    isJdShop
                };
            });
        } catch (error) {
        } finally {
            this.loadingRecommend = false;
        }
    }


    async fetchGoodsCount() {
        try {
            const {count} = await Api.cartGoodsCount();
            this.goodsCount = count;
        } catch (error) {
        }
    }


    get recommendPage() {
        return {
            size: this.recommendPageSize,
            num: this.recommendPageNum
        };
    }


    constructor() {
        makeAutoObservable(this)
    }
}

const store = new Cart();
export default store;
